import { Ref } from 'react'
import { Spin } from 'antd'
import styled from '@emotion/styled'

interface Props {
  ref?: Ref<HTMLDivElement>
}

export const FooterLoadingMoreIndicator = ({ ref }: Props) => {
  return (
    <Spin size="large">
      <Base ref={ref} />
    </Spin>
  )
}

const Base = styled.div`
  display: flex;
  justify-content: center;
  margin: 16px 0;
`
